import React, { useEffect, useState } from 'react';
import { Modal } from '../ui';
import {
  catalogUsagesService,
  CatalogType,
  CatalogUsageItem,
} from '../../services/catalogUsagesService';

interface UsagesModalProps {
  open: boolean;
  catalogType: CatalogType;
  objectId: string;
  objectLabel: string;
  onClose: () => void;
}

export const UsagesModal: React.FC<UsagesModalProps> = ({
  open,
  catalogType,
  objectId,
  objectLabel,
  onClose,
}) => {
  const [loading, setLoading] = useState(false);
  const [usages, setUsages] = useState<CatalogUsageItem[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!open || !objectId) return;
    let cancelled = false;
    setLoading(true);
    setError(null);
    catalogUsagesService
      .getUsages(catalogType, objectId)
      .then((res) => {
        if (!cancelled) setUsages(res.usages);
      })
      .catch((err) => {
        if (!cancelled) setError(err?.message || 'Erreur lors du chargement des usages');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [open, catalogType, objectId]);

  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      title={`Activé dans — ${objectLabel} (${usages.length})`}
      size="md"
    >
      {loading ? (
        <div className="text-gray-500">Chargement…</div>
      ) : error ? (
        <div className="text-red-600 text-sm">{error}</div>
      ) : usages.length === 0 ? (
        <div className="text-gray-500 text-sm">Cet objet n'est activé dans aucun tenant.</div>
      ) : (
        <>
        <p className="text-xs text-gray-500 mb-2">
          Liste des couples (client, domaine) où cet objet est actif.
        </p>
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-gray-200 text-left">
              <th className="py-2 px-2">Client</th>
              <th className="py-2 px-2">Slug</th>
              <th className="py-2 px-2">Domaine</th>
            </tr>
          </thead>
          <tbody>
            {usages.map((u) => (
              <tr key={`${u.client_id}-${u.domain_code}`} className="border-b border-gray-100">
                <td className="py-2 px-2">{u.client_name}</td>
                <td className="py-2 px-2 text-gray-500">{u.client_slug}</td>
                <td className="py-2 px-2">{u.domain_code}</td>
              </tr>
            ))}
          </tbody>
        </table>
        </>
      )}
    </Modal>
  );
};

export default UsagesModal;
